<!--  -->
<template>
  <div>
    <div class>
      <Steps :active="0"
             :stepsShow="stepsShow"
             align-center>
        <Step :title="$t('course.csbase')"/>
        <Step :title="$t('course.cscondition')"
              @click.native="on_click('cscondition')" />
        <Step :title="$t('course.csprice')"
              @click.native="on_click('csprice')" />
        <Step :title="$t('course.csrpt')"
              @click.native="on_click('csrpt')" />
        <Step :title="$t('course.csinvest')"
              @click.native="on_click('csinvest')" />
        <Step :title="$t('course.csability')"
              @click.native="on_click('csability')" />
      </Steps>
    </div>
    <br />
    <div class='divMessage' style=" word-wrap:break-word; word-break:break-all;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ changeMessage }}</div>
    <br />

    <el-card class="aui-card--fill"
             shadow="never">
      <el-form label-position="top"
               label-width="145px"
               :model="dataForm"
               :rules="dataRule"
               ref="dataForm">
        <el-row>
          <!-- 品牌 -->
          <el-col :span="6">
            <el-form-item :label="$t('course.courseBrand')"
                          prop="courseBrand">
              <el-select v-model="dataForm.courseBrand"
                         multiple
                         collapse-tags
                         :placeholder="$t('course.select')">
                <el-option v-for="(item,index) in courseBrandArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>

              </el-select>
            </el-form-item>
          </el-col>
          <!-- 课程分类 单选树组件测试 -->
          <el-col :span="6">
            <el-form-item :label="$t('couse.coursecatalogid')"
                          prop="courseCatalogId">
              <span slot="label" @click="dialogVisible = true">{{$t('couse.coursecatalogid')}}
                  <em class="el-icon-question" style="color: #1C69D3;cursor: pointer"></em>
              </span>

              <el-dialog
                      :visible.sync="dialogVisible"
                      width="800px"
              >
                  <div class="logbox" style="height:560px;overflow:auto;padding:10px 10px">
                    <el-table
                            :data="courseCatalogData"
                            :span-method="(...arg)=>objectSpanMethod(...arg,courseCatalogData)"
                            border
                            style="width: 100%;">
                      <el-table-column
                              width="150px"
                              :resizable="false"
                              header-align="center"
                              align="center"
                              prop="courseCatalogFirst"
                              label="课程分类一级">
                      </el-table-column>
                      <el-table-column
                              width="255px"
                              :resizable="false"
                              header-align="center"
                              align="center"
                              prop="courseCatalogSecond"
                              label="课程分类二级">
                      </el-table-column>
                      <el-table-column
                              header-align="center"
                              :resizable="false"
                              prop="catalogCont"
                              label="课程内容">
                      </el-table-column>
                    </el-table>
                  </div>
                 <span slot="footer" class="dialog-footer">
                 </span>
              </el-dialog>
              <catalogtree @catelogObj="catelogObj"
                           :defaultProps="defaultPropsz"
                           :showArray="showVehicleClassList"
                           :showValue="showValue"
                           :url="queryTreeUrl"
                           :status="'classStatus'"
                           ref="classRef"></catalogtree><!--@node-click="cateloglist"@getParent_checked="getParent_checked"-->
            </el-form-item>
          </el-col>

          <!-- 最大人数 max_number course.maxNumber -->
          <el-col :span="6">
            <el-form-item :label="$t('course.maxNumber')"
                          prop="maxNumber">
              <el-input v-model.number="dataForm.maxNumber"
                        :maxlength="9"></el-input>
            </el-form-item>
          </el-col>
          <!-- 最小人数 min_number course.minNumber-->
          <el-col :span="6">
            <el-form-item :label="$t('course.minNumber')"
                          prop="minNumber">
              <el-input v-model="dataForm.minNumber"
                        oninput="value=value.replace(/[^\d.]/g,'')"
                        maxlength="9"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 课程代码 -->
        <el-row>
          <el-col :span="6">
            <el-form-item :label="$t('course.courseCode')">
              <el-input v-model="dataForm.courseCode"
                        placeholder="系统自动生成"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>

          <!-- 项目课程 project_course_flag course.projectCourseFlag-->
          <el-col :span="6">
            <el-form-item :label="$t('course.projectCourseFlag')"
                          prop="projectCourseFlag">
              <span slot="label">{{$t('course.projectCourseFlag')}}
                <el-tooltip placement="bottom-start" effect="light" >
                  <div slot="content">
                    若为项目类课程，且允许培训师排课，请选择是。
                  </div>
                  <em class="el-icon-question" style="color: #1C69D3"></em>
                </el-tooltip>
              </span>
              <el-select v-model="dataForm.projectCourseFlag"
                         :placeholder="$t('course.select')">
                <el-option v-for="(item,index) in courseBooleanArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 标准时长（天） course_days course.courseDays /^\d*(\.?\d{0,2})/g)[0]-->
          <el-col :span="6">
            <el-form-item :label="$t('course.courseDays')"
                          prop="courseDays">
              <el-input v-model="dataForm.courseDays"
                        maxlength="9"
                        oninput="value=value.replace(/[^\d.]/g,'')"></el-input>
            </el-form-item>
<!--            <el-tooltip placement="top-start" effect="light" >-->
<!--              <div slot="content">{{ $t('course.titletian') }}</div>-->
<!--            <el-form-item-->
<!--                          prop="courseDays">-->
<!--              <span>{{$t('course.courseDays')}}</span>-->
<!--              <el-tooltip placement="top-start" effect="light" >-->
<!--                <div slot="content">{{ $t('course.titletian') }}</div>-->
<!--                <em class="el-icon-question"></em>-->
<!--              </el-tooltip>-->
<!--&lt;!&ndash;              <span slot="label" class="el-form-item__label2">{{$t('course.courseDays')}}<em class="el-icon-question"></em></span>&ndash;&gt;-->
<!--              <el-input v-model="dataForm.courseDays"-->
<!--                        maxlength="9"-->
<!--                        oninput="value=value.replace(/[^\d.]/g,'')"></el-input>-->
<!--            </el-form-item>-->
          </el-col>

          <!-- 课程类型 course_kind course.courseKind-->
          <el-col :span="6">
            <el-form-item :label="$t('course.courseKind')"
                          prop="courseKind">
              <el-select v-model="dataForm.courseKind"
                         placeholder=" ">
                <el-option v-for="(item,index) in courseKindArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 课程中文名称  course_name_cn course.courseNameCn -->
        <el-row>
          <el-col :span="6">
            <el-form-item :label="$t('course.courseNameCn')"
                          prop="courseNameCn">
              <el-input v-model="dataForm.courseNameCn"
                        :maxlength="30"></el-input>
            </el-form-item>
          </el-col>
          <!-- 课程英文名称  -->
          <el-col :span="6">
            <el-form-item :label="$t('course.courseNameEn')"
                          prop="courseNameEn">
              <el-input v-model="dataForm.courseNameEn"
                        :maxlength="200"></el-input>
            </el-form-item>
          </el-col>
          <!-- 是否设置及格分数线 passMarkFlag 111-->
          <el-col :span="6">
            <el-form-item prop="passMarkFlag">
              <span slot="label">{{$t('course.passMarkFlag')}}
                <el-tooltip placement="bottom-start" effect="light" >
                  <div slot="content">
                    <p>是否设置及格分数线的更改将同步到所有已发布/未发布排期，已结束排期不会发生变更。</p>
                  </div>
                  <em class="el-icon-question" style="color: #1C69D3"></em>
                </el-tooltip>
              </span>
              <el-select v-model="dataForm.passMarkFlag"
                         :placeholder="$t('course.select')">
                <el-option v-for="(item,index) in courseBooleanArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 及格分数 passMarkScore v-if="this.dataForm.orgType === '' -->
          <el-col :span="6">
            <div v-if="this.dataForm.passMarkFlag=='10'">
              <el-form-item prop="passMarkScore">
                <span slot="label">{{$t('course.passMarkScore')}}
                <el-tooltip placement="bottom-start" effect="light" >
                  <div slot="content">
                    <p>及格分数的更改将同步到所有已发布/未发布排期，已结束排期不会发生变更。</p>
                  </div>
                  <em class="el-icon-question" style="color: #1C69D3"></em>
                </el-tooltip>
              </span>
                <el-input v-model="dataForm.passMarkScore"
                          :maxlength="9"
                          oninput="value=value.replace(/[^\d.]/g,'')"></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row>

          <!-- 课程团队分类 course_team_catalog_id course.courseTeamCatalogId -->
          <el-col :span="12">
            <el-form-item prop="courseTeamCatalogFirst"
                          :label="$t('couse.courseteamcatalogid')">
              <div id="container">
                <div class="box01"
                     style="width: auto; float: left;">
                  <el-select v-model="dataForm.courseTeamCatalogFirst"
                             placeholder="请选择"
                             @change="GetcourseTeamCatalog($event)">
                    <el-option v-for="(item,index) in select1"
                               :key="index"
                               :label="item.name"
                               :value="item.code">
                    </el-option>
                  </el-select>
                </div>
                <div class="box02"
                     style="width: auto; float: left;">
                  <el-select v-model="dataForm.courseTeamCatalogSecond"
                             placeholder=" "
                             :loading="loading"
                             @change="getList($event)">
                    <el-option v-for="(item,index) in select2"
                               :key="index"
                               :label="item.name"
                               :value="item.code"></el-option>
                  </el-select>
                </div>
              </div>
            </el-form-item>
          </el-col>
          <!-- APP页面显示分类  -->
          <el-col :span="12">

            <el-form-item  prop="appCourseCatalogList"
                           style="width:60% !important;"
                           class="cascader">
              <span style="color:#f56c6c;" v-show="appCourseCatalogListFlas">*</span>
              <label style="color:#606266"> {{$t('couse.appcatalog')}}</label>
              <el-tooltip placement="bottom-start" effect="light" >
                <div slot="content">
                  课程会显示所选择的悦学苑APP目录层级下
                </div>
                <em class="el-icon-question" style="color: #1C69D3"></em>
              </el-tooltip>
              <el-cascader
                      v-model="dataForm.appCourseCatalogList"
                      :options="options"
                      ref="cascaderValue"
                      change-on-select
                      :props="optionProps"
                      @change="getAppCatalog"
                      clearable>
              </el-cascader>
<!--              <div class="clearClose" @click="clearValue" v-if="dataForm.appCourseCatalogList.length">-->
<!--                <em class="el-icon-circle-close"-->
<!--                   style="color:#ccc;font-size: medium"-->
<!--                ></em>-->
<!--              </div>-->
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 课程介绍文本框  course_Introduction course.courseIntroductionCn-->
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('course.courseIntroduction')"
                          prop="courseIntroductionCn">
              <el-input v-model="dataForm.courseIntroductionCn"
                        type="textarea"
                        :maxlength="2000"
                        show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 封面图片  peppa-file-service.training-d.svc.cluster.local -->
        <!--        <el-row>-->
        <!--          <el-col :span="12">-->
        <!--            <el-form-item prop="file"-->
        <!--                          class="upload-img-form"-->
        <!--                          :label="$t('course.covers')"-->
        <!--                          ref="upload">-->
        <!--              <el-upload class="upload-img1"-->
        <!--                         :action=picURL-->
        <!--                         :limit="1"-->
        <!--                         :headers="token"-->
        <!--                         :on-exceed="handleExceed"-->
        <!--                         :file-list="coverFileList"-->
        <!--                         list-type="picture"-->
        <!--                         :on-success="coverFilePut"-->
        <!--                         :on-remove="coverFilerm"-->
        <!--                         :auto-upload="true"-->
        <!--                         :before-upload="beforUpload"-->
        <!--                         accept="image/png,image/jpg,image/jpeg">-->
        <!--                <el-button slot="trigger"-->
        <!--                           size="small"-->
        <!--                           type="primary">选取文件</el-button>-->
        <!--                &lt;!&ndash; <el-button style="margin-left: 10px;"-->
        <!--                           size="small"-->
        <!--                           type="success"-->
        <!--                           @click="submitUploadCover">上传</el-button> &ndash;&gt;-->
        <!--                <div slot="tip"-->
        <!--                     class="el-upload__tip">建议尺寸比例2.2：1，不超过4M，格式为png,jpeg及jpg</div>-->
        <!--              </el-upload>-->
        <!--            </el-form-item>-->
        <!--          </el-col>-->
        <!--          &lt;!&ndash; </el-row> &ndash;&gt;-->
        <!--          &lt;!&ndash; banner上传 &ndash;&gt;-->
        <!--          <el-col :span="12">-->
        <!--            <el-form-item prop="file"-->
        <!--                          class="upload-img-form"-->
        <!--                          :label="$t('course.banner')"-->
        <!--                          ref="upload">-->
        <!--              <el-upload class="upload-img"-->
        <!--                         :action=picURL-->
        <!--                         :limit="1"-->
        <!--                         :headers="token"-->
        <!--                         :auto-upload="true"-->
        <!--                         :on-exceed="handleExceed"-->
        <!--                         :file-list="bannerFileList"-->
        <!--                         list-type="picture"-->
        <!--                         :on-success="bannerFilePut"-->
        <!--                         :on-remove="bannerFilerm"-->
        <!--                         :before-upload="beforUpload"-->
        <!--                         accept="image/png,image/jpg,image/jpeg">-->
        <!--                <el-button slot="trigger"-->
        <!--                           size="small"-->
        <!--                           type="primary">选取文件</el-button>-->
        <!--                &lt;!&ndash; <el-button style="margin-left: 10px;"-->
        <!--                           size="small"-->
        <!--                           type="success"-->
        <!--                           @click="submitUpload">上传</el-button> &ndash;&gt;-->
        <!--                <div slot="tip"-->
        <!--                     class="el-upload__tip">建议尺寸比例2.2：1，不超过4M，格式为png,jpeg及jpg</div>-->
        <!--              </el-upload>-->
        <!--            </el-form-item>-->
        <!--          </el-col>-->
        <!--        </el-row>-->
        <el-row>
          <el-col :span="12">
            <el-form-item prop="file"
                          class="upload-img-form"
                          :label="$t('course.covers')"
                          ref="upload">
              <div class="img-div" @click="modifyCoverImg" style="display: table-cell; text-align:center; vertical-align:middle;border:1px dashed #c6c6c6; width:300px; height:300px" >
                <img alt="" :src="coverUrl" style="width: 100%;  max-width: 100%;max-height: 100%; "/>
                <div class="modify-img"
                     v-show="headModifyCoverShow">
                </div>
              </div>
              <div >建议尺寸比例2.2：1，不超过4M，格式为png,jpeg及jpg</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="file"
                          class="upload-img-form"
                          :label="$t('course.banner')"
                          ref="upload">
              <div class="img-div" @click="modifyBannerImg" style="display: table-cell; text-align:center; vertical-align:middle;border:1px dashed #c6c6c6; width:300px; height:300px" >
                <img alt="" :src="bannerUrl" style="width: 100%; max-width: 100%;max-height: 100%; " />
                <div class="modify-img"
                     v-show="headModifyBannerShow">
                </div>
              </div>
              <div >建议尺寸比例2.2：1，不超过4M，格式为png,jpeg及jpg</div>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 课程标签 -->
        <el-row class="row-mar-l">
          <el-col :span="24">
            <el-form-item :label="$t('course.tag')"
                          prop="tagName"
                          style="width: 108.5%!important;"
                          v-model="dataForm.courseLabel">
              <!--              <tag :checkedList="checkList"-->
              <!--                   :brandCode="bussinessTypeChecked"-->
              <!--                   :overLabelShow="false"></tag>-->
              <tag :checkedList="checkList"
                   :bussinessTypeId = "bussinessTypeId"
                   :brandCode="bussinessTypeChecked"
                   @getBussinessType="getBussinessType"
                   @changeCheckedList="changeCheckedList"
                   ref='tagTree'
                   @fatherMethod="fatherMethod"></tag>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- AG关联课程代码 ag_codes oninput="value=value.replace(/[，]/g,'')" -->
        <el-row>
          <el-col :span="24">
            <el-form-item prop="agCodes">
              <span style="color:#f56c6c;">*</span> {{ $t('course.agCodes') }} <span style="font-size:12px;">（若无对应KTC，请填写#NO-KTC； 需要填写多个KTC时，请用英文逗号隔开）</span>
              <el-input v-model.trim="dataForm.agCodes"
                        placeholder=" "
                        :maxlength="512"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <a @click="downloadagcode"> <span>AG关联课程代码说明</span> </a>
          </el-col>
        </el-row>
        <!--  -->
        <!-- <el-form-item>
          <el-button type="primary"
                     @click="onSubmit">保存</el-button>
        </el-form-item> -->
      </el-form>
      <!-- 弹窗, 修改图片 -->
      <modifyCoverImg v-if="modifyCoverImgVisible"
                      @refreshImg="refreshCoverImg"
                      ref="modifyCoverImg"></modifyCoverImg>
      <!-- 弹窗, 修改图片 -->
      <modifyBannerImg v-if="modifyBannerImgVisible"
                       @refreshImg="refreshBannerImg"
                       ref="modifyBannerImg"></modifyBannerImg>
    </el-card>
    <div>
      <el-row style="float:right; margin-bottom: 60px;">
        <el-col :span="16">
          <div class="grid-content" />
        </el-col>
        <el-button v-if="$hasPermission('learning:courseinfo:csbaseSave') && $hasPermission('learning:courseinfo:csconditionSave')"
                   @click="onSubmitfornext"
                   type="primary">{{ $t("course.saveAndNext") }}</el-button>
        <el-button v-if="$hasPermission('learning:courseinfo:csbaseSave')"
                   @click="onSubmit"
                   type="primary">{{ $t("course.save") }}</el-button>
        <ZElButton @click="cancel">{{ $t("course.cancel") }}</ZElButton>
      </el-row>
    </div>
    <CourseVerification
      :csDialogVisible="csDialogVisible"
      @courseVerificationOk="courseVerificationOk"
      :courseVerificationForm="courseVerificationForm"
      :total="courseTotal"
      :courseResType="courseResType"
      :courseObj="courseObj"
      @coursePageOk="coursePageOk"
      ref="courseCurrent"
    ></CourseVerification>
    <CourseVerificationConfirm
      :csDialogConfirmVisible="csDialogConfirmVisible"
      :csDialogVisible="csDialogVisible"
      :formData="csDialogFormData"
      :courseVerificationForm="courseVerificationForm"
       :total="courseTotal"
      :courseResType="courseResType"
      :courseObj="courseObj"
      @coursePageConfirmOk="coursePageConfirmOk"
    ></CourseVerificationConfirm>
  </div>
</template>

<script>
  // 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  // 例如：import 《组件名称》 from '《组件路径》';
  import { getIconList, treeDataTranslate,treeDataWithDisableTranslate} from '@/utils'
  import CourseVerificationConfirm from '@/components/rm/courseVerificationConfirm/index'
  import Tag from '../../common/courselabel'
  import debounce from 'lodash/debounce'
  import catalogtree from '../../common/catalogtreeS'
  import courseTeamCatalogtree from '../../common/courseTeamCatalogTreeS'
  import Steps from '../../common/steps/index'
  import Step from '../../common/steps/src/step'
  import ZElButton from '../../common/button/index'
  import modifyCoverImg from '../../common/modifyImg/modifyCoverImg'
  import modifyBannerImg from '../../common/modifyImg/modifyBannerImg'
  import CourseVerification from '@/components/rm/courseVerification/index'
  export default {
    // import引入的组件需要注入到对象中才能使用

    components: { Tag, courseTeamCatalogtree, catalogtree, Steps, Step, ZElButton, modifyCoverImg, modifyBannerImg, CourseVerification, CourseVerificationConfirm },
    props: ['message', 'isbasicinfo', 'courseid'],
    props1: {
      data: {
        type: Array,
        default: () => {
          return []
        }
      }
    },
    inject: ['toTop'],
    data () {
      return {
        dialogVisible: false,
        parent_checked_data: [],
        changeMessage: this.message,
        headModifyCoverShow: false,
        headModifyBannerShow: false,
        coverUrl: require('../../../../../assets/img/learning/cover.jpg'),
        bannerUrl: require('../../../../../assets/img/learning/banner.jpg'),
        modifyCoverImgVisible: false,
        modifyBannerImgVisible: false,
        // newMessage: this.message,
        stepsShow: false, // 是否保存过
        picURL: `${window.SITE_CONFIG['apiURL']}/learning/courseinfo/picupload/`,
        dowURL: `${window.SITE_CONFIG['apiURL']}/learning/courseinfo/downloadpic/`,
        // dowURL: `http://localhost:8001/api/learning/courseinfo/downloadpic/`,

        // dowURL_test: `http://localhost:8001/api/learning/courseinfo/downloadpic/`,
        // picURL: `/api/learning/courseinfo/picupload/`,
        // dowURL: `/api/learning/courseinfo/downloadpic/`,
        token: { token: sessionStorage.getItem('v1token').replace('"', '').replace('"', '') },
        dowRokens: `?token=${this.getStorage(this.GLOBAL.TOKEN)}`,
        // 课程分类初始化树
        treeData: [],
        // TODO 模板 开始
        course: { code: '' },
        // 课程分类树
        defaultPropsz: {
          children: 'children',
          label: 'catalogNameCn',
          id: 'catalogId'
        },
        optionProps: {
          children: 'subClassifyList',
          label: 'classifyName',
          value: 'classifyId'
        },
        checkedValTeamlist: [],
        checkedValCourselist: [],
        showVehicleClassList: [],
        showValue: '',
        agurl: '/learning/courseinfo/download',
        queryTreeUrl: '/learning/coursecatalog/list?type=10',
        checkList: [],
        bussinessTypeId: 4,
        bussinessTypeChecked: 1,
        courseId: '',
        dataIsbasicinfo: false,
        // TODO 模板 结束
        courseBrandArr: this.enums['courseBrand'], // course品牌
        courseBooleanArr: this.enums['CouresYesNoFlag'], // 项目课程
        courseKindArr: this.enums['courseKind'], // 课程类型
        iconList: [],
        iconListVisible: false,
        coverFileList: [], // 上传封面图片回显
        bannerFileList: [], // 上传banner封面图片回显
        dataForm: {
          menuId: '',
          type: 1,
          name: '',
          sysCode: '',
          resourceList: [],
          permissions: '',
          orderNum: 0,
          hide: '1',
          icon: '',
          courseId: '',
          courseStatus: '10',
          courseBrand: '',
          // courseTeamCatalogId: '', // 课程团队分类
          courseCatalogName: '',
          courseCatalogId: '', // 课程分类
          maxNumber: '',
          minNumber: '',
          courseNameCn: '',
          courseNameEn: '',
          courseIntroductionCn: '',
          courseDays: '',
          projectCourseFlag: '20',
          courseKind: '10',
          courseCode: '',
          agCodes: '',
          agFileId: '',
          courseLabel: '',
          coverPhotoId: '',
          bannerPhotoId: '',
          passMarkFlag: '20',
          passMarkScore: '',
          courseTeamCatalogFirst: '', // 团队一级分类
          courseTeamCatalogSecond: '',
          appCourseCatalogList: [],
          courseTeamCatalogName: '',
          rewardScore: '',
          fixedCourseNameCn: '',
          fixedCourseNameEn: '',
          firstLevelClassifyId: '',
          firstLevelClassifyName: '',
          secondLevelClassifyId: '',
          secondLevelClassifyName: '',
          thirdLevelClassifyId: '',
          thirdLevelClassifyName: '',
          fourLevelClassifyId: '',
          fourLevelClassifyName: '',
          courseLabelList: []
        },
        options: [],
        select1: this.enums['catalogidList1'],
        allteamcatalog: this.enums['catalogidList2'],
        // select1: [
        //   { value: '10', label: 'BBS-50' },
        //   { value: '20', label: 'BBS-51' },
        //   { value: '30', label: 'BBS-52' },
        //   { value: '40', label: 'BBS-53' },
        //   { value: '50', label: 'H5' },
        //   { value: '60', label: 'Non TA' }],
        loading: false,
        select2: [],
        select3: [
          { value: '10', label: '销售' },
          { value: '20', label: '金融' },
          { value: '30', label: '管理' },
          { value: '40', label: '零件' },
          { value: '50', label: '服务' },
          { value: '60', label: '机电' },
          { value: '70', label: '钣喷' }
        ],
        select4: [],
        allapp: [
          { pro: '10', label: 'BMW' },
          { pro: '20', label: '金融内训课程包' },
          // { pro: '30', label: 'MA' }, { pro: '30', label: 'S&M' }, { pro: '30', label: 'Others' },
          { pro: '40', label: '零件业务' }, // { pro: '40', label: 'Service' }, { pro: '40', label: 'Others' }, { pro: '40', label: 'CCM' },
          { pro: '50', label: '服务' },
          { pro: '60', label: '机电' }, // { pro: '60', label: 'AS Coaching' }, { pro: '60', label: 'SF' },
          { pro: '70', label: '钣喷' }
        ],
        // APP层级分类红星 是否显示
        appCourseCatalogListFlas : true,
        csDialogVisible: false,
        csDialogConfirmVisible: false,
        courseVerificationForm: [],
        courseVerificationFormList: [],
        courseTotal: 0,
        courseResType: 10,
        courseObj: {
          courseId: '',
          catalogId: '',
          courseType: ''
        },
        saveType: 'save',
        csDialogFormData: {
          type: 0
        },
        courseCatalogData: [
          { courseCatalogFirst: '经销商', courseCatalogSecond: '基础岗/管理岗/新能源 一级培训/认证',catalogCont: '与政策相关的一级或未设置级别课程，包括人员资质政策，同时也包括其他部门的政策。' },
          { courseCatalogFirst: '经销商', courseCatalogSecond: '基础岗/管理岗/新能源 二级培训/认证',catalogCont: '与政策相关的二级课程，包括人员资质政策，同时也包括其他部门的政策。' },
          { courseCatalogFirst: '经销商', courseCatalogSecond: '基础岗/管理岗/新能源 三级培训/认证',catalogCont: '课程架构设置为三级的课程。' },
          { courseCatalogFirst: '经销商', courseCatalogSecond: '专题培训',catalogCont: '非政策相关的常规课程或定制化培训。' },
          { courseCatalogFirst: '经销商', courseCatalogSecond: '辅导',catalogCont: '驻点辅导项目且课程名称中需写明“辅导”。' },
          { courseCatalogFirst: '经销商', courseCatalogSecond: '评估中心',catalogCont: '管理岗评估中心项目。' },
          { courseCatalogFirst: '经销商', courseCatalogSecond: '高级管理培训',catalogCont: '管理岗MBA项目、管理岗发展中心进阶项目。' },
          { courseCatalogFirst: '经销商', courseCatalogSecond: '上市培训',catalogCont: '上市活动培训。' },
          { courseCatalogFirst: '经销商', courseCatalogSecond: '大赛',catalogCont: '大赛相关培训。' },
          { courseCatalogFirst: '经销商', courseCatalogSecond: '会议和其他',catalogCont: '邀请经销商参与的研讨会或活动。' },
          { courseCatalogFirst: '合作院校', courseCatalogSecond: '-',catalogCont: '面向BEST学生开展的培训&认证。' },
          { courseCatalogFirst: 'BMW Group 内部', courseCatalogSecond: '-',catalogCont: '需要让培训师在app端看到、但是不需要让经销商等看到的混合式学习课程。' },
          { courseCatalogFirst: '培训学院专用', courseCatalogSecond: '培训师_课程开发',catalogCont: '包括混合式学习，面对面课程开发，线上学习课程开发等纯课程开发相关内容。' },
          { courseCatalogFirst: '培训学院专用', courseCatalogSecond: '培训师_课程传递',catalogCont: '包括面对面课程传递授的课前准备和课后跟进，课程支持，直播，VCT课程传递，认证监考等。' },
          { courseCatalogFirst: '培训学院专用', courseCatalogSecond: '培训师_培养发展',catalogCont: '包括对培训师个人能力提升、认证以及他人能力提升、认证等课程内容。' },
          { courseCatalogFirst: '培训学院专用', courseCatalogSecond: '培训师_项目管理',catalogCont: '包括纯项目管理及外部沟通等。' },
          { courseCatalogFirst: '培训学院专用', courseCatalogSecond: '培训师_其他',catalogCont: '包括参与性的会议、研讨会，请假等。' },
          { courseCatalogFirst: '培训学院专用', courseCatalogSecond: '非培训学院预订',catalogCont: 'SF, CRM Coaching等其它部门预订。' },
          { courseCatalogFirst: '培训学院专用', courseCatalogSecond: '其他',catalogCont: '其他课程。' }
        ]
      }
    },

    // 监听属性 类似于data概念
    computed: {
      dataRule () {
        let comarule = (rule, value, callback) => {
          if (String(value).match('，')) {
            callback(new Error(' 不允许出现 "，"号 '))
          }

          callback()
        }
        let maxnum = (rule, value, callback) => {
          if (isNaN(value)) {
            callback(new Error('必须为正整数'))
          }
          if (this.dataForm.maxNumber) {
            if (value === 0) {
              callback(new Error('最大人数必须大于0'))
            }
          }
          if (this.dataForm.minNumber) {
            if (value < this.dataForm.minNumber) {
              callback(new Error('最大人数必须大于等于最小人数'))
            }
            this.$refs.dataForm.validateField('minNumber')
          }
          callback()
        }
        let minmaxnumber = (rule, value, callback) => {
          console.log('this.dataForm.minNumber')
          console.log(value)
          let ss = /(^[0-9]\d*$)/.test(value)
          console.log(ss)
          if (isNaN(value)) {
            callback(new Error('必须为正整数'))
          }
          // if (!/(^[0-9]\d*$)/.test(value)) {
          //   callback(new Error('最小人数不能为空'))
          // }
          if (this.dataForm.maxNumber) {
            if (value > this.dataForm.maxNumber) {
              callback(new Error('最小人数必须小于等于最大人数'))
            }
            // this.$refs.dataForm.validateField('maxNumber')
          }
          callback()
        }
        return {
          // 新团队分类
          courseTeamCatalogFirst: [{ required: true, message: this.$t('course.plsin') + this.$t('couse.courseteamcatalogid'), trigger: 'blur' }],
          // app课程分类
          appCourseCatalogList: [{required: false, message: '此项不能为空', trigger:'blur'}],
          courseBrand: [{ required: true, message: this.$t('course.plsin') + this.$t('course.courseBrand'), trigger: 'blur' }],
          courseCatalogId: [{ required: true, message: this.$t('course.plsin') + this.$t('course.courseclassify'), trigger: 'blur,change' }],
          maxNumber: [{ required: true, message: this.$t('course.plsin') + this.$t('course.maxNumber'), trigger: 'blur' }, { validator: maxnum, trigger: 'blur' }],
          minNumber: [{ required: true, message: this.$t('course.plsin') + this.$t('course.minNumber'), trigger: 'blur' }, { validator: minmaxnumber, trigger: 'blur' }],
          projectCourseFlag: [{ required: true, message: this.$t('course.plsin') + this.$t('course.projectCourseFlag'), trigger: 'blur' }],
          courseNameCn: [{ required: true, message: this.$t('course.plsin') + this.$t('course.courseNameCn'), trigger: 'blur' }, { max: 35, message: '长度超过35个字符', trigger: 'blur' }],
          courseNameEn: [{ required: true, message: this.$t('course.plsin') + this.$t('course.courseNameEn'), trigger: 'blur' }, { max: 200, message: '长度超过200个字符', trigger: 'blur' }],
          courseIntroductionCn: [{ required: true, message: this.$t('course.plsin') + this.$t('course.courseIntroduction'), trigger: 'blur' }],
          courseDays: [{ required: true, message: this.$t('course.plsin') + this.$t('course.courseDays'), trigger: 'blur' },
            { validator (rule, value, callback) {
                if (/(^[0-9]+(\.[0-9]{1,2})?$)/.test(value)) {
                  callback()
                } else {
                  callback(new Error('请输入正确的标准时长'))
                }
              },
              trigger: 'blur'
            }
          ],
          passMarkFlag: [{ required: true, message: this.$t('course.plsin') + this.$t('course.passMarkFlag'), trigger: 'change' }],
          passMarkScore: [{ required: true, message: this.$t('course.plsin') + this.$t('course.passMarkScore'), trigger: 'blur' },
            {
              validator (rule, value, callback) {
                if (value <= 0) {
                  callback(new Error('请输入正确的及格分数'))
                }
                if (/(^[0-9]+(\.[0-9]{1,2})?$)/.test(value)) {
                  callback()
                } else {
                  callback(new Error('请输入正确的及格分数'))
                }
              },
              trigger: 'blur'
            }
          ],
          courseKind: [{ required: true, message: this.$t('course.plsin') + this.$t('course.courseKind'), trigger: 'change' }],
          agCodes: [{ required: true, message: this.$t('course.plsin') + this.$t('course.agCodes'), trigger: 'blur' }, { validator: comarule, trigger: 'blur' }]

        }
      }
    },
    // 监控data中的数据变化
    watch: {
      isbasicinfo: function (newVal, oldVal) {
        this.dataIsbasicinfo = newVal // newVal即是chartData
      },
      'dataForm.type' (val) {
        this.$refs['dataForm'].clearValidate()
        this.getMenuList()
      }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {
      // var courseId = this.$route.query.courseId
      // this.courseId = courseId
      // this.$eventHub.$on('showCourse', (data) => {
      //   this.initialization()
      //   console.log('csbase init')
      //   this.getCourseCode(courseId)
      // })
     // treeData
      this.getOptions()
      this.init()
      this.$eventHub.$on('addCourse', (data) => {
        this.appCourseCatalogListFlas = true
        console.log('addCourse ')
        this.adds='1'
        this.showValue=''
        this.changeMessage = ''
        this.changeCheckedList([])
        setTimeout(()=>{
          this.$refs.tagTree.overLabelsopen()
          this.$refs['classRef'].resetChecked();
        },0)
        //this.$refs.tagTree.initData([])
        this.$refs['dataForm'].resetFields();
        console.log('addCourse')
        this.again()
        this.courseId = ''
        this.stepsShow = false
      })
      this.$eventHub.$on('showCourse', (data) => {
        console.log('showCourse base ')
        this.init()
        this.stepsShow = true
      })

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {
      this.value = this.$attrs.multiple ? [] : ''
      console.log(this.dataForm.appCourseCatalogList)
    },
    beforeCreate () {
      console.log('beforeCreate')
    }, // 生命周期 - 创建之前
    beforeMount () {
      console.log('beforeMount')
    }, // 生命周期 - 挂载之前
    beforeUpdate () {
      console.log('beforeUpdate')
    }, // 生命周期 - 更新之前
    updated () {
      console.log('updated')
    }, // 生命周期 - 更新之后
    beforeDestroy () {
      this.$eventHub.$off('addCourse')
      this.$eventHub.$off('showCourse')
    }, // 生命周期 - 销毁之前
    destroyed () {
      console.log('destroyed')
    }, // 生命周期 - 销毁完成
    activated () {
      console.log('activated ')
      this.visible = true
      this.queryVehinfoClass()// 新增app课程显示问题
      this.$nextTick(() => {
        this.getBaseInfo()
        this.iconList = getIconList()
        this.dataForm.resourceList = []
        this.getMenuList().then(() => {
          if (this.$route.query.menuId !== undefined) {
            this.dataForm.menuId = this.$route.query.menuId
            this.getInfo()
          }
        })
      })
    },

    // 方法集合
    methods: {
      refreshCoverImg(data) {
        console.log('refreshImg')
        console.log(data)
        this.coverUrl = this.dowURL + data.url
        this.dataForm.coverPhotoId = data.url
        this.headModifyCoverShow = true

      },
      refreshBannerImg(data) {
        console.log('refreshBannerImg')
        console.log(data)
        this.bannerUrl = this.dowURL + data.url
        this.dataForm.bannerPhotoId = data.url
        this.headModifyBannerShow = true

      },
      modifyCoverImg() {
        this.modifyCoverImgVisible = true
        this.$nextTick(() => {
          this.$refs.modifyCoverImg.init(this.dataForm.userId, 'cover')
        })
      },
      modifyBannerImg() {
        this.modifyBannerImgVisible = true
        this.$nextTick(() => {
          this.$refs.modifyBannerImg.init(this.dataForm.userId, 'banner')
        })
      },
      getBussinessType (val) {
        this.dataForm.bussinessTypeId = 3
        this.bussinessTypeId = 3
      },
      // 关闭校验弹框
      courseVerificationOk(val) {
        if (val === 'cancel') {
          console.log("0000000")
          this.csDialogVisible = false
          this.csDialogConfirmVisible =false
        } else {
          if (this.saveType === 'save') {
            this.onSubmitFun()
          } else {
            this.submitNextFun()
          }
          this.csDialogVisible = false
        }
        console.log('courseVerificationFormOk ')
      },
      coursePageConfirmOk(value, type) {
        console.log(type)
        console.log(this.courseVerificationForm)
        console.log('csDialogFormData========',this.csDialogFormData)
        this.csDialogConfirmVisible = false
        if (value === 'submit') {
          if (type === 20) {
            if (this.courseVerificationForm.length > 0) {
              this.csDialogVisible = true
            } else {
              if (this.saveType === 'save') {
                this.onSubmitFun()
              } else {
                this.submitNextFun()
              }
            }
          }
          // if (this.courseVerificationForm.length > 0) {
          //   this.csDialogVisible = true
          // } else {
          //   if (this.saveType === 'save') {
          //     this.onSubmitFun()
          //   } else {
          //     this.submitNextFun()
          //   }
          // }
        }
      },
      coursePageOk(val) {
        let page = val
        console.log(page)
        this.csDialogConfirmVisible= false
        let limit = 10
        let courseId = this.dataForm.courseId
        let catalogId = this.dataForm.courseCatalogId
        let courseType = this.dataForm.courseKind
        this.$request.get(
          `/learning/base/offeringinfo/checkUpdateCourseType?courseId=${courseId}&catalogId=${catalogId}&courseType=${courseType}&page=${page}&limit=${limit}`,
          {}
        ).then((res, total, code, data) => {
          console.log(res)
          this.courseVerificationForm = res.list.records
        }).catch((err) => {
          console.log(err)
        })
      },
      // 根据选择标签 封装dataForm中的Label信息
      changeCheckedList (array) {
        console.log('changeCheckdList')
        console.log(array)
        this.checkList = array
        this.dataForm.courseLabelList = []
        this.dataForm.courseLabel = ''
        for (let i = 0; i < array.length; i++) {
          let courseLabel = {}
          courseLabel.labelId = array[i].labelId
          courseLabel.labelContent = array[i].labelName
          this.dataForm.courseLabelList.push(courseLabel)
          if (i === array.length - 1) {
            this.dataForm.courseLabel = this.dataForm.courseLabel + array[i].labelName
          } else {
            this.dataForm.courseLabel = this.dataForm.courseLabel + array[i].labelName + ','
          }
        }

        console.log(this.dataForm.courseLabelList)
        console.log(this.dataForm.courseLabel)
      },
      // 重新勾选业务标签
      fatherMethod () {
        this.checkList = []
        // 已选择的标签
        this.checkList = this.dataForm.courseLabelList ? this.dataForm.courseLabelList : []
        this.checkList.forEach(o => {
          o.labelName = o.labelContent
        })
        console.log('fatherMethod')
        console.log(this.checkList)
        console.log(this.dataForm.courseLabelList)

        // 特殊情况，自己国际化
        // const language = VueI18n.locale
        // if (language === 'zh-CN') {
        //   this.checkList.forEach(o => {
        //     o.labelName = o.labelNameCn
        //   })
        // } else {
        //   this.checkList.forEach(o => {
        //     o.labelName = o.labelNameEn
        //   })
        // }
      },
      test (item) {
        console.log(item)
      },
      GetcourseTeamCatalog (prov) {
        let tempArry = []
        this.select2 = []
        if (this.dataForm.courseTeamCatalogSecond !== null || this.dataForm.courseTeamCatalogSecond === '') {
          this.dataForm.courseTeamCatalogSecond = ''
        }
        for (var val of this.allteamcatalog) {
          var code = val.code.slice(0, 2)
          if (prov === code) {
            tempArry.push({ name: val.name, code: val.code })
          }
          this.select2 = tempArry
        }
      },
      getAppCatalog (prov) {
        this.dataForm.firstLevelClassifyId = ''
        this.dataForm.firstLevelClassifyName = ''
        this.dataForm.secondLevelClassifyId = ''
        this.dataForm.secondLevelClassifyName = ''
        this.dataForm.thirdLevelClassifyId =''
        this.dataForm.thirdLevelClassifyName = ''
        this.dataForm.fourLevelClassifyId = ''
        this.dataForm.fourLevelClassifyName = ''
        if (prov.length) {
          let labels = this.$refs['cascaderValue'].currentLabels
          if (labels.length > 0) {
            this.dataForm.firstLevelClassifyId = prov[0]
            this.dataForm.firstLevelClassifyName = labels[0]
          }
          if (labels.length > 1) {
            this.dataForm.secondLevelClassifyId = prov[1]
            this.dataForm.secondLevelClassifyName = labels[1]
          }
          if (labels.length > 2) {
            this.dataForm.thirdLevelClassifyId = prov[2]
            this.dataForm.thirdLevelClassifyName = labels[2]
          }
          if (labels.length > 3) {
            this.dataForm.fourLevelClassifyId = prov[3]
            this.dataForm.fourLevelClassifyName = labels[3]
          }
        }
      },
      getList (opt) {
        console.log(opt)
      },
      hiddenPopper () {
        this.$refs.select.blur()
      },

      handleNodeClick (data) {
        if (this.$attrs.multiple) {
          if (this.value.indexOf(data.label) > -1) return false
          this.value.push(data.label)
          this.valueIds.push(data.id)
        } else {
          this.value = data.label
          this.valueIds = data.id
        }
        this.$emit('getValueIds', this.valueIds)
        this.hiddenPopper()
      },

      handleSelectClear () {
        this.$emit('input', '')
      },

      handleRemoveTag (value) {
        let fileterValue = this.value.filter(item => item !== value)
        this.$emit('input', fileterValue)
      },

      // 注释 ：清空dataform方法
      again () {
        console.log('again')
        this.coverUrl = require('../../../../../assets/img/learning/cover.jpg'),
                this.bannerUrl = require('../../../../../assets/img/learning/banner.jpg'),
                this.dataForm = {
                  menuId: '',
                  type: 1,
                  name: '',
                  sysCode: '',
                  parentId: '0',
                  resourceList: [],
                  permissions: '',
                  orderNum: 0,
                  hide: '1',
                  icon: '',
                  courseId: '',
                  courseStatus: '',
                  courseBrand: '',
                  courseTeamCatalogId: '', // 课程团队分类
                  courseCatalogName: '',
                  courseCatalogId: '', // 课程分类
                  maxNumber: '',
                  minNumber: '',
                  appCourseCatalogList: [],
                  firstLevelClassifyId: '',
                  firstLevelClassifyName: '',
                  secondLevelClassifyId: '',
                  secondLevelClassifyName: '',
                  thirdLevelClassifyId: '',
                  thirdLevelClassifyName: '',
                  fourLevelClassifyId: '',
                  fourLevelClassifyName: '',
                  courseNameCn: '',
                  courseNameEn: '',
                  courseIntroductionCn: '',
                  courseDays: '',
                  projectCourseFlag: '20',
                  courseKind: '10',
                  courseCode: '',
                  agCodes: '',
                  agFileId: '',
                  courseLabel: '',
                  coverPhotoId: '',
                  bannerPhotoId: '',
                  passMarkFlag: '20',
                  passMarkScore: '',
                  courseTeamCatalogFirst: '', // 团队一级分类
                  courseTeamCatalogSecond: '',
                  fixedCourseNameCn: '',
                  fixedcourseNameEn: ''
                }
      },

      downloadagcode () {
        this.$request.download(this.agurl, 'KTC_Liste.2023.6')
      },
      queryVehinfoClass () {
        // if(this.showVehicleClassList.length===0){
        //   return
        // }
        this.$request.get(
                this.queryTreeUrl,
                { 'disable': false }
        ).then((res, total, code, data) => {
          let resultList = treeDataWithDisableTranslate(data.data, 'catalogId', 'parentCatalogId')
          let arr = JSON.parse(JSON.stringify(resultList))[0].children
          this.treeData = arr.filter(it => it.catalogId === 6)[0].children
          let flag = false
          for (let i = 0; i < this.treeData.length; i++) {
            for (let k = 0; k < this.showVehicleClassList.length; k++) {
              if (this.treeData[i].catalogId == this.showVehicleClassList[k]) {
                flag = true
                break;
              }
            }
          }
          if (flag) {
            this.dataRule.appCourseCatalogList[0].required = false
            this.appCourseCatalogListFlas = false // 初始化时
          } else {
            this.dataRule.appCourseCatalogList[0].required = true
            this.appCourseCatalogListFlas = true
          }
        }).catch((err) => {
          console.log(err)
        })
      },
      clearValue() {
        this.dataForm.appCourseCatalogList = []
        this.dataForm.firstLevelClassifyId = ''
        this.dataForm.firstLevelClassifyName = ''
        this.dataForm.secondLevelClassifyId = ''
        this.dataForm.secondLevelClassifyName = ''
        this.dataForm.thirdLevelClassifyId =''
        this.dataForm.thirdLevelClassifyName = ''
        this.dataForm.fourLevelClassifyId = ''
        this.dataForm.fourLevelClassifyName = ''
      },
      // 初始化
      init () {
        // debugger
        this.again()
        // this.getCourseCode(this.$route.query.courseId)
        this.initialization()
        //this.queryVehinfoClass()// 新增app课程显示问题

      },
      // 新增时候点击圆圈回显
      addInit (onCourseid) {
        this.again()
        this.dataForm.courseId = onCourseid
        this.getBaseInfo()
        this.getCourseCode(onCourseid)
      },
      // 获取数据
      initialization () {
        if (this.$route.query.courseId !== undefined) {
          this.dataForm.courseId = this.$route.query.courseId
          this.getBaseInfo()
        }
      },
      getBaseInfo () {
        this.$request.get('/learning/courseinfo/getWithBrand/' + this.dataForm.courseId
        ).then((res, total, code, data) => {
          this.$store.commit('getCourse', data.data)
          // 20190925 修复 赋值
          // this.dataForm = data.data
          for (let key in data.data) {
            if (this.dataForm.hasOwnProperty(key)) {
              if (data.data[key] !== null || data.data[key] !== undefined) {
                this.dataForm[key] = data.data[key]
              }
            }
          }
          // 2019-11-21
          let tempArry = []
          this.select2 = []
          if (this.dataForm.courseTeamCatalogSecond !== null || this.dataForm.courseTeamCatalogSecond === '') {
            this.dataForm.courseTeamCatalogSecond = ''
          }
          var casend=data.data.courseTeamCatalogSecond+''
          casend=casend.slice(0, 2)
          for (var val of this.allteamcatalog) {
            var code = val.code.slice(0, 2)
            if (casend === code) {
              tempArry.push({ name: val.name, code: val.code })
            }
            this.select2 = tempArry
          }
          // this.checkList = []
          this.dataForm.courseLabelList = data.data.courseLabelList
          this.checkList = []
          // 已选择的标签
          this.checkList = this.dataForm.courseLabelList ? this.dataForm.courseLabelList : []
          this.checkList.forEach(o => {
            o.labelName = o.labelContent
          })
          console.log('getBaseInfo')
          console.log(this.checkList)
          console.log(this.dataForm.courseLabelList)

          // 2019-10-14 追加 固定值
          this.dataForm.fixedCourseNameCn = data.data.courseNameCn
          this.dataForm.fixedCourseNameEn = data.data.courseNameEn


          this.coverUrl = this.dowURL +  data.data.coverPhotoId + this.dowRokens
          this.dataForm.coverPhotoId = data.data.coverPhotoId

          this.bannerUrl = this.dowURL + data.data.bannerPhotoId + this.dowRokens
          this.dataForm.bannerPhotoId = data.data.bannerPhotoId
          if (data.data.courseCatalogNameFirst != null && data.data.courseCatalogNameFirst != '') {
            this.showValue = data.data.courseCatalogNameFirst+','+this.dataForm.courseCatalogName
          } else {
            this.showValue = this.dataForm.courseCatalogName
          }
          this.$refs.classRef.getShowValue(this.showValue)
          this.dataForm.rewardScore = data.data.rewardScore
          console.log('getWithBrand')
          console.log(this.dataForm)

          if (data.data === null) {

          } else {
            let arr = []
            if (data.data.firstLevelClassifyId) {
              arr.push(data.data.firstLevelClassifyId)
            }
            if (data.data.secondLevelClassifyId) {
              arr.push(data.data.secondLevelClassifyId)
            }
            if (data.data.thirdLevelClassifyId) {
              arr.push(data.data.thirdLevelClassifyId)
            }
            if (data.data.fourLevelClassifyId) {
              arr.push(data.data.fourLevelClassifyId)
            }
            this.dataForm.appCourseCatalogList = arr
            // console.log("初始化后 判断appCourseCatalogList 的长度")
            if(arr.length === 0){
             // 注释掉 this.appCourseCatalogListFlas = false
            }

            console.log(this.dataForm.appCourseCatalogList)
            /*this.dataForm.appCourseCatalogList = data.data.appCourseCatalogList.map(app => {
              return Number(app)
            })
            this.getAppCatalog(this.dataForm.appCourseCatalogList)*/
            this.dataForm.courseTeamCatalogSecond = data.data.courseTeamCatalogSecond
            console.log(this.dataForm.courseCatalogId)
            this.showVehicleClassList = [this.dataForm.courseCatalogId]
            // this.$refs.classRef.init()
            console.log(this.showVehicleClassList )
            // this.showVehicleClassListVisible = [this.dataForm.courseTeamCatalogId]
            let letCourse = ''
            if (this.$route.query.courseId === '' || this.$route.query.courseId === undefined || this.$route.query.courseId === null) {
              letCourse = this.courseid
            } else {
              letCourse = this.$route.query.courseId
            }
            setTimeout(()=> {
              this.getCourseCode(letCourse)
            },0)
          }
        }).catch((err) => {
          console.log(err)
        })
      },
      getCourseCode (courseId) {
        // debugger
        console.log('getCourseCode')
        console.log(this.message)
        if (courseId !== undefined) {
          console.log('进入 !== undefined')
          this.$emit('onCourseCode', '课程代码 :' + this.dataForm.courseCode + '  课程中文名:' + this.dataForm.fixedCourseNameCn + ' 课程英文名:' + this.dataForm.fixedCourseNameEn)
          if (this.message === undefined || this.message === '') {
            this.changeMessage = '课程代码 :' + this.dataForm.courseCode + '  课程中文名:' + this.dataForm.fixedCourseNameCn + ' 课程英文名:' + this.dataForm.fixedCourseNameEn
            this.stepsShow = true
          }
          this.course.code = courseId
          this.courseId = courseId
          this.queryVehinfoClass()// 新增app课程显示问题
          // 新增奖励积分
          this.sendrewardScore()
        } else {
          // console.log('else ')
          // this.$emit('onCourseCode', '')
          // this.courseId = ''
        }
      },
      submitUpload () {
        this.$refs.upload.submit()
      },
      // 提交封面图片 我们需要从这个服务器上获取返回的
      submitUploadCover () {
        this.$refs.upload.submit()
      },
      // 限制1文件钩子
      handleExceed (files, fileList) {
        // this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
        this.$message.warning(`当前只能上传一张图片，请先删除后再次上传！`)
      },
      // 上传成功后触发 保存当前data数据到datafrom
      coverFilePut (res, file, coverFileList) {
        console.log('coverFilePut ')
        console.log(res)
        this.dataForm.coverPhotoId = res.data
        console.log(this.dataForm)
      },
      coverFilerm (res, file, coverFileList) {
        this.dataForm.coverPhotoId = 'cover.jpg'
      },
      bannerFilePut (res, file, coverFileList) {
        this.dataForm.bannerPhotoId = res.data
      },
      bannerFilerm (res, file, coverFileList) {
        this.dataForm.bannerPhotoId = 'banner.jpg'
      },
      sendMsg () {
        this.toTop()
        this.$emit('onShowModer', 'csconditionsend')
        this.$emit('onCourseCode', '课程代码 :' + this.dataForm.courseCode + '  课程中文名:' + this.dataForm.fixedCourseNameCn + ' 课程英文名:' + this.dataForm.fixedCourseNameEn)
        this.$emit('onCourseId', this.dataForm.courseId)
        this.stepsShow = true
        this.sendrewardScore()
      },
      // 获取奖励积分
      sendrewardScore () {
        // this.$message('*************' + this.dataForm.rewardScore)
        console.log('获取奖励积分')
        console.log(this.dataForm)
        if (this.dataForm.rewardScore !== '' && this.dataForm.rewardScore !== null && this.dataForm.rewardScore !== undefined) {
          this.$emit('onrewardScore', this.dataForm.rewardScore)
        }
      },
      sendSave () {
        this.$emit('onShowModer', 'csconditionSave')
        // 添加奖励积分
        this.sendrewardScore()
        this.tabRemove()
        this.$router.push({
          name: 'learning-course-courseinfo'
        })
      },
      on_click (e) {
        if ((this.courseId !== '' && this.courseId !== undefined) || this.isbasicinfo || this.dataIsbasicinfo) {
          this.$confirm('离开本页将不保存当前正在编辑的数据, 确定离开? ', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$emit('onShowModer', e)
            // 测试跳转页面
            this.$emit('onCourseCode', '课程代码 :' + this.dataForm.courseCode + '  课程中文名:' + this.dataForm.fixedCourseNameCn + ' 课程英文名:' + this.dataForm.fixedCourseNameEn)
            this.$emit('onCourseId', this.dataForm.courseId)
          }).catch((err) => {
            console.log(err)
          })
        }
      },
      onSubmitfornext: debounce(function () {
        // console.log(this.options)
        // console.log(this.dataForm.appCourseCatalogList)

        // console.log("onSubmitFornext")
        // console.log(this.dataForm.courseCatalogId)
        // console.log(this.treeData)
        // let courseId = this.dataForm.courseId
        // let catalogId = this.dataForm.courseCatalogId
        // let courseType = this.dataForm.courseKind
        // let page = 1
        // let limit = 10
        // this.courseObj = {
        //   courseId: this.dataForm.courseId,
        //   catalogId: this.dataForm.courseCatalogId,
        //   courseType: this.dataForm.courseKind
        // }
        //  console.log('csDialogFormData========',this.csDialogFormData)
        // if (this.stepsShow) {
        //   this.$request.get(
        //     `/learning/base/offeringinfo/checkUpdateCourseType?courseId=${courseId}&catalogId=${catalogId}&courseType=${courseType}&page=${page}&limit=${limit}`,
        //     {}
        //   ).then((res, total, code, data) => {
        //     console.log(res)
        //     if (res === null || res.list.records.length === 0 || res.list === null) {
        //       console.log('没有影响')
        //       if(res === null) {
        //         this.submitNextFun()
        //       } else {
        //         this.courseVerificationForm = []
        //         if (res.type === 20) {
        //           this.csDialogConfirmVisible = true
        //           this.csDialogFormData.type = res.type
        //           this.courseResType = res.type
        //         } else {
        //           this.csDialogConfirmVisible = true
        //           this.csDialogFormData.type = res.type
        //           this.courseResType = res.type

        //           // this.submitNextFun()
        //         }
        //       }

        //     } else {
        //       // let listData = res.list.records
        //       this.courseVerificationForm = res.list.records
        //       console.log(' this.courseVerificationForm=====', this.courseVerificationForm)

        //       if (res.type === 20) {
        //         this.csDialogConfirmVisible = true
        //         this.csDialogFormData.type = res.type
        //       } else {
        //          if(this.courseVerificationForm.length>0){
        //         this.courseTotal = res.list.total
        //         this.courseResType = res.type
        //          this.csDialogVisible = true
        //          this.csDialogConfirmVisible = flase
        //       }else{
        //         this.csDialogConfirmVisible = true
        //         this.csDialogFormData.type = res.type
        //       }

        //       }

        //       this.$refs.courseCurrent.currentPageFun()
        //       this.courseTotal = res.list.total
        //       this.courseResType = res.type
        //       this.saveType = 'saveNext'
        //     }
        //   }).catch((err) => {
        //     console.log(err)
        //   })
        // } else {
        //   this.submitNextFun()
        // }
         this.submitNextFun()
      }, 1000, { 'leading': true, 'trailing': false }),

      submitNextFun() {
        let flag = false
        this.treeData.forEach(it => {
          console.log("treeDate forEach")
          console.log(this.dataForm.courseCatalogId+"")
          console.log(it.catalogId+"")
          if (this.dataForm.courseCatalogId+"" === it.catalogId+"") {
            flag = true
          }
        })

        console.log("onSubmitfornext")
        console.log(flag)

        if (flag) {
          this.dataRule.appCourseCatalogList[0].required = false
          this.$refs['dataForm'].clearValidate('appCourseCatalogList')
          // this.dataForm.appCourseCatalogList = []
          // this.clearValue()
        } else {
          this.dataRule.appCourseCatalogList[0].required = true
        }

        if (this.dataForm.appCourseCatalogList.length >= 2 && flag === false) {
          let option = this.dataForm.appCourseCatalogList[0]
          for(let j=0; j<this.options.length; j++){
            let classifyId = this.options[j].classifyId
            if(classifyId === option){
              let appFlag = false
              if(option !== undefined && option !== null){
                let subClassifyListLet = this.options[j].subClassifyList

                let appcourseCatalog = this.dataForm.appCourseCatalogList[1]
                for(let i=0; i<subClassifyListLet.length; i++){
                  let subClassi = subClassifyListLet[i].classifyId
                  if(subClassi === appcourseCatalog){
                    appFlag = true
                  }
                }
              }
              if(appFlag === false ){
                this.$message({
                  message: 'APP课程层级第一级目录不能选择',
                  type: 'error',
                  duration: 2000
                })
                return false
              }
            }
          }
        }


        console.log('保存下一步')
        console.log(this.dataForm)
        if (this.dataForm.courseTeamCatalogSecond === null || this.dataForm.courseTeamCatalogSecond === '') {
          return this.$message.error(this.$t('course.plsin') + this.$t('couse.courseteamcatalogid'))
        }
        // this.getCCode()
        this.$refs['dataForm'].validate((valid) => {
          if (!valid) {
            return false
          }
          console.log('111111111')
          console.log(this.dataForm.maxNumber)
          console.log(/(^[0-9]\d*$)/.test(this.dataForm.maxNumber))
          if (/(^[0-9]\d*$)/.test(this.dataForm.maxNumber) !== true) {
            this.$message({
              message: '最大人数必须为正整数',
              type: 'error',
              duration: 2000
            })
            return false
          }
          if (/(^[0-9]\d*$)/.test(this.dataForm.minNumber) !== true) {
            this.$message({
              message: '最小人数必须为正整数',
              type: 'error',
              duration: 2000
            })
            return false
          }
          if (flag === false && this.dataForm.appCourseCatalogList.length === 1) {
            this.$message({
              message: 'APP课程层级第一级目录不能选择',
              type: 'error',
              duration: 2000
            })
            return false
          }
          // 临时新增课程团队分类名称 start
          let courseTeamCatalogFirstTmp = ''
          for (let l of this.select1) {
            if (l.code === this.dataForm.courseTeamCatalogFirst) {
              courseTeamCatalogFirstTmp = l.name
            }
          }

          let courseTeamCatalogSecondTmp = ''
          for (let l of this.select2) {
            if (l.code === this.dataForm.courseTeamCatalogSecond) {
              courseTeamCatalogSecondTmp = l.name
            }
          }
          this.dataForm.courseTeamCatalogName = courseTeamCatalogFirstTmp + ',' + courseTeamCatalogSecondTmp
          console.log('this.dataForm.courseTeamCatalogName')
          console.log(this.dataForm.courseTeamCatalogName)
          // 临时新增课程团队分类名称 end

          // cover.jpg
          if (this.dataForm.coverPhotoId === '' || this.dataForm.coverPhotoId === null || this.dataForm.coverPhotoId === undefined) {
            this.dataForm.coverPhotoId = 'cover.jpg'
          }
          // banner.jpg
          if (this.dataForm.bannerPhotoId === '' || this.dataForm.bannerPhotoId === null || this.dataForm.bannerPhotoId === undefined) {
            this.dataForm.bannerPhotoId = 'banner.jpg'
          }
          this.$request.post(
                  `/learning/courseinfo/soudp`,
                  this.dataForm
          ).then((res, total, code, data) => {
            if (data.code === 13000000) {
              this.$message({
                message: this.$t(data.msg),
                type: 'error',
                duration: 2000
              })
            } else if (data.code === 1) {
              // this.dataForm = data.data
              for (let key in data.data) {
                if (this.dataForm.hasOwnProperty(key)) {
                  if (data.data[key] !== null || data.data[key] !== undefined) {
                    this.dataForm[key] = data.data[key]
                  }
                }
              }
              // 2019-10-14 追加 固定值
              this.dataForm.fixedCourseNameCn = data.data.courseNameCn
              this.dataForm.fixedCourseNameEn = data.data.courseNameEn

              let coverFileLists = {}
              coverFileLists.name = data.data.coverPhotoId
              coverFileLists.url = this.dowURL + data.data.coverPhotoId + this.dowRokens
              this.coverFileList = []
              this.coverFileList.push(coverFileLists)

              // bannerFileList
              let bannerFileLists = {}
              bannerFileLists.name = data.data.bannerPhotoId
              bannerFileLists.url = this.dowURL + data.data.bannerPhotoId + this.dowRokens
              this.bannerFileList = []
              this.bannerFileList.push(bannerFileLists)

              this.dataForm.rewardScore = data.data.rewardScore
              console.log(this.dataForm)

              if (data.data.courseDays !== null) {
                this.dataForm.courseDays = data.data.courseDays.toFixed(2)
              }
              if (data.data.passMarkScore) {
                this.dataForm.passMarkScore = data.data.passMarkScore.toFixed(2)
              }
              if (data.data.courseId != null || data.data.courseId !== '') {
                this.sendMsg()
                // console.log('success')
              }
              //courseCode，courseNameCn，dataForm.courseNameEn，courseKind，courseStatus
              this.$store.commit('getCourse', data.data)
              this.$message({
                message: this.$t('prompt.success'),
                type: 'success',
                duration: 500,
                onClose: () => {
                  this.visible = false
                  this.$emit('refreshDataList')
                }
              })
              this.again()
            }
          }).catch((err) => {
            console.log(err)
          })
        })
      },
      // 表单提交
      onSubmit: debounce(function () {
        // let courseId = this.dataForm.courseId
        // let catalogId = this.dataForm.courseCatalogId
        // let courseType = this.dataForm.courseKind
        // let page = 1
        // let limit = 10
        // this.courseObj = {
        //   courseId: this.dataForm.courseId,
        //   catalogId: this.dataForm.courseCatalogId,
        //   courseType: this.dataForm.courseKind
        // }
        // if (this.stepsShow) {
        //   this.$request.get(
        //     `/learning/base/offeringinfo/checkUpdateCourseType?courseId=${courseId}&catalogId=${catalogId}&courseType=${courseType}&page=${page}&limit=${limit}`,
        //     {}
        //   ).then((res, total, code, data) => {
        //     console.log(res)
        //     if (res === null || res.list.records.length === 0 || res.list === null) {
        //       console.log('没有影响')
        //       if (res === null) {
        //         this.onSubmitFun()
        //       } else {
        //         this.courseVerificationForm = []
        //         if (res.type === 20) {
        //           this.csDialogConfirmVisible = true
        //           this.csDialogFormData.type = res.type
        //           this.courseResType = res.type
        //         } else {
        //           this.csDialogConfirmVisible = true
        //           this.csDialogFormData.type = res.type
        //           this.courseResType = res.type
        //           // this.onSubmitFun()
        //         }
        //       }

        //     } else {
        //       // let listData = res.list.records
        //       this.courseVerificationForm = res.list.records
        //       // this.csDialogVisible = true
        //       if (res.type === 20) {
        //         this.csDialogConfirmVisible = true
        //         this.csDialogFormData.type = res.type
        //       } else {
        //         this.csDialogConfirmVisible = true
        //         this.csDialogFormData.type = res.type
        //         // this.csDialogVisible = true
        //       }
        //       this.courseTotal = res.list.total
        //       this.courseResType = res.type
        //       this.saveType = 'save'
        //     }
        //   }).catch((err) => {
        //     console.log(err)
        //   })
        // } else {
        //   this.onSubmitFun()
        // }
        this.onSubmitFun()
      }, 1000, { 'leading': true, 'trailing': false }),

      onSubmitFun() {
        let flag = false
        this.treeData.forEach(it => {
          if (this.dataForm.courseCatalogId+"" === it.catalogId+"") {
            flag = true
          }
        })

        if (flag) {
          this.dataRule.appCourseCatalogList[0].required = false
          this.$refs['dataForm'].clearValidate('appCourseCatalogList')
          // this.dataForm.appCourseCatalogList = []
          // this.clearValue()
        } else {
          this.dataRule.appCourseCatalogList[0].required = true
        }


        if (this.dataForm.courseTeamCatalogSecond === null || this.dataForm.courseTeamCatalogSecond === '') {
          this.$message({
            message: this.$message.error(this.$t('course.plsin') + this.$t('couse.courseteamcatalogid')),
            type: 'error',
            duration: 2000
          })
          return
        }
        if (this.dataForm.appCourseCatalogList.length >= 2 && flag === false) {
          let option = this.dataForm.appCourseCatalogList[0]
          for(let j=0; j<this.options.length; j++){
            let classifyId = this.options[j].classifyId
            if(classifyId === option){
              let appFlag = false
              if(option !== undefined && option !== null){
                let subClassifyListLet = this.options[j].subClassifyList

                let appcourseCatalog = this.dataForm.appCourseCatalogList[1]
                for(let i=0; i<subClassifyListLet.length; i++){
                  let subClassi = subClassifyListLet[i].classifyId
                  if(subClassi === appcourseCatalog){
                    appFlag = true
                  }
                }
              }
              if(appFlag === false ){
                this.$message({
                  message: 'APP课程层级第一级目录不能选择',
                  type: 'error',
                  duration: 2000
                })
                return false
              }
            }
          }
        }
        if (this.dataForm.appCourseCatalogList.length === 1 && flag === false) {
          this.$message({
            message: 'APP课程层级第一级目录不能选择',
            type: 'error',
            duration: 2000
          })
          return false
        }
        this.$refs['dataForm'].validate((valid) => {
          if (!valid) {
            return false
          }
          if (/(^[0-9]\d*$)/.test(this.dataForm.maxNumber) !== true) {
            this.$message({
              message: '最大人数必须为正整数',
              type: 'error',
              duration: 2000
            })
            return false
          }
          if (/(^[0-9]\d*$)/.test(this.dataForm.minNumber) !== true) {
            this.$message({
              message: '最小人数必须为正整数',
              type: 'error',
              duration: 2000
            })
            return false
          }
          // 临时新增课程团队分类名称 start
          let courseTeamCatalogFirstTmp = ''
          for (let l of this.select1) {
            if (l.code === this.dataForm.courseTeamCatalogFirst) {
              courseTeamCatalogFirstTmp = l.name
            }
          }

          let courseTeamCatalogSecondTmp = ''
          for (let l of this.select2) {
            if (l.code === this.dataForm.courseTeamCatalogSecond) {
              courseTeamCatalogSecondTmp = l.name
            }
          }
          this.dataForm.courseTeamCatalogName = courseTeamCatalogFirstTmp + ',' + courseTeamCatalogSecondTmp
          console.log('this.dataForm.courseTeamCatalogName')
          console.log(this.dataForm.courseTeamCatalogName)
          // 临时新增课程团队分类名称 end

          // cover.jpg
          if (this.dataForm.coverPhotoId === '' || this.dataForm.coverPhotoId === null || this.dataForm.coverPhotoId === undefined) {
            this.dataForm.coverPhotoId = 'cover.jpg'
          }
          // banner.jpg
          if (this.dataForm.bannerPhotoId === '' || this.dataForm.bannerPhotoId === null || this.dataForm.bannerPhotoId === undefined) {
            this.dataForm.bannerPhotoId = 'banner.jpg'
          }
          // this.getAppCatalog(this.dataForm.appCourseCatalogList)
          console.log(this.dataForm)
          this.$request.post(
                  `/learning/courseinfo/soudp`,
                  this.dataForm
          ).then((res, total, code, data) => {
            if (data.code === 13000000) {
              this.$message({
                message: this.$t(data.msg),
                type: 'error',
                duration: 2000
              })
            } else if (data.code === 1) {
              // this.dataForm = data.data
              for (let key in data.data) {
                if (this.dataForm.hasOwnProperty(key)) {
                  if (data.data[key] !== null || data.data[key] !== undefined) {
                    this.dataForm[key] = data.data[key]
                  }
                }
              }
              // 2019-10-14 追加 固定值
              this.dataForm.fixedCourseNameCn = data.data.courseNameCn
              this.dataForm.fixedCourseNameEn = data.data.courseNameEn

              let coverFileLists = {}
              coverFileLists.name = data.data.coverPhotoId
              coverFileLists.url = this.dowURL + data.data.coverPhotoId + this.dowRokens
              this.coverFileList = []
              this.coverFileList.push(coverFileLists)

              // bannerFileList
              let bannerFileLists = {}
              bannerFileLists.name = data.data.coverPhotoId
              bannerFileLists.url = this.dowURL + data.data.coverPhotoId + this.dowRokens
              this.bannerFileList = []
              this.bannerFileList.push(bannerFileLists)

              this.dataForm.rewardScore = data.data.rewardScore
              if (data.data.courseDays !== null) {
                this.dataForm.courseDays = data.data.courseDays.toFixed(2)
              }
              if (data.data.passMarkScore !== null) {
                this.dataForm.passMarkScore = data.data.passMarkScore.toFixed(2)
              }
              this.$message({
                message: this.$t('prompt.success'),
                type: 'success',
                duration: 500,
                onClose: () => {
                  this.visible = false
                  this.$emit('refreshDataList')
                }
              })
              this.sendSave()
            }
            this.again()
          }).catch((err) => {
            console.log(err)
          })
        })
      },

      // 异步获取菜单下级
      getChildList (tree, resolve) {
        this.getTreeChild(tree.data.menuId, resolve)
      },
      getTreeChild (menuId, resolve) {
        this.$request.get(
                '/sys/menu/getChildrenlist',
                {
                  menuId: menuId
                }
        ).then((res) => {
          resolve(res)
        }).catch((err) => {
          console.log(err)
        })
      },
      async getOptions () {
        await this.$request.get(
                '/learning/courseinfo/getAppCourseCatalogList'
        ).then((res, total, code, data) => {
          this.options =  data.data
        }).catch((err) => {
          console.log(err)
        })
      },
      // 处理合并行的数据
      getSpanArr: function(data, spanKey) {
        let spanArr = []
        let pos = ''
        for (let i = 0; i < data.length; i++) {
          if (i === 0) {
            spanArr.push(1)
            pos = 0
          } else {
            // 判断当前元素与上一个元素是否相同
            if (data[i][spanKey] === data[i - 1][spanKey]) {
              spanArr[pos] += 1
              spanArr.push(0)
            } else {
              spanArr.push(1)
              pos = i
            }
          }
        }
        return spanArr
      },
      // 当前行row、当前列column、当前行号rowIndex、当前列号columnIndex
      objectSpanMethod: function({ row, column, rowIndex, columnIndex }, data) {
        // columnIndex判断第一列或第二列合并 列数从0开始
        if(columnIndex == 0){
          // column.property是表头的key
          let spanArr = this.getSpanArr(data, column.property)
          const _row = spanArr[rowIndex]
          const _col = _row > 0 ? 1 : 0
          return {
            rowspan: _row,
            colspan: _col
          }
        }
      },
      // 获取菜单列表
      getMenuList () {
        return this.$request.get(
                '/sys/menu/list', {}
        ).then((res) => {
          this.menuList = res
        }).catch((err) => {
          console.log(err)
        })
      },
      // 获取信息
      getInfo () {
        this.$request.get(`/sys/menu/info/${this.dataForm.menuId}`).then((res, total, code, data) => {
          this.dataForm = {
            ...this.dataForm,
            ...data.result
          }
        }).catch((err) => {
          console.log(err)
        })
      },
      // 课程分类调用树
      catelogObj: function (data) {
        this.showVehicleClassList = [data.catalogId]
        let flag = false
        this.treeData.forEach(it => {
          if (data.catalogId+"" === it.catalogId+"") {
            flag = true

          }
        })
        console.log("catelogObj" + flag)
        console.log(JSON.stringify(this.treeData))

        if (flag) {
          this.dataRule.appCourseCatalogList[0].required = false
         this.$refs['dataForm'].clearValidate('appCourseCatalogList')
         // this.dataForm.appCourseCatalogList = []
          this.appCourseCatalogListFlas = false
        } else {
          this.appCourseCatalogListFlas = true
          this.dataRule.appCourseCatalogList[0].required = true
        }
        this.dataForm.courseCatalogId = '' + data.catalogId
        this.dataForm.courseCatalogName = data.catalogNameCn
        if (data.courseCatalogNameFirst != null && data.courseCatalogNameFirst != '') {
          this.showValue = data.courseCatalogNameFirst + ',' + data.catalogNameCn
        } else {
          this.showValue = data.catalogNameCn
        }
        this.$refs.classRef.getShowValue(this.showValue)
        if (isNaN(this.dataForm.courseCatalogId)) {
          this.dataForm.courseCatalogId = ''
          this.dataForm.courseCatalogName = ''
        }
        if(this.adds!=='1'){
          this.$refs.dataForm.validateField('courseCatalogId')
        }
      },
      iconListCurrentChangeHandle (icon) {
        this.dataForm.icon = icon
        this.iconListVisible = false
      },
      // 删除当前页面
      tabRemove () {
        let tabName = this.$store.state.contentTabsActiveName
        if (tabName === 'home') {
          return false
        }
        this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
        if (this.$store.state.contentTabs.length <= 0) {
          this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
          return false
        }
        // 当前选中tab被删除
        if (tabName === this.$store.state.contentTabsActiveName) {
          this.$router.push({ name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name })
        }
      },
      // 上传前
      beforUpload (file) {
        var ext = file.name.substring(file.name.lastIndexOf('.') + 1)
        console.log(ext)
        const exts = ext === 'png' || ext === 'PNG' || ext === 'jpg' || ext === 'JPG' || ext === 'jpeg' || ext === 'JPEG'
        const is4M = file.size / 1024 / 1024 < 4
        if (!exts) {
          this.$message({
            message: '上传文件必须为 png/jpg/jpeg 格式',
            type: 'error'
          })
          return false
        }
        if (!is4M) {
          this.$message({
            message: '上传图片过大，请选择小于4M的图片，重新上传',
            type: 'error'
          })
          return false
        }
        return true
      },
      // 取消按钮
      cancel () {
        this.$confirm('离开本页将不保存当前正在编辑的数据, 确定离开? ', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.tabRemove()
        }).catch((err) => {
          console.log(err)
        })
      }
    } // 如果页面有keep-alive缓存功能，这个函数会触发
  }
</script>
<style lang='scss' scoped>
  // @import url(); 引入公共css类
  .grid-content {
    border-radius: 4px;
    min-height: 20px;
  }
  .el-row {
    margin-bottom: 20px;
  }
  .el-row a {
    cursor: pointer;
  }
  .tag-option {
    display: none !important;
  }
  .cascader{
    &:hover .clearClose{
      display: block;
    }
  }
  .clearClose {
    display: none;
    width:17px;
    height:21px;
    background: #fff;
    z-index:99;
    top: 5px;
    right: 8px;
    position: absolute;
  }
   .el-form-item {
    width: 80.1% !important;
    margin-bottom: 6px !important;
  }
   .el-form-item__label {
    line-height: 14px !important;
    margin-bottom: 6px !important;
  }
   .el-textarea .el-input__count {
    bottom: -26px !important;
  }
   .el-table th > .cell {
    font-weight: bold;
  }
</style>
